import React from 'react';
import './App.css';
import {Header} from "./components/Header";
import {Home} from "./pages/Home";
import {Footer} from "./components/Footer";
import {Route, Routes} from "react-router-dom";
import {CPlusPlus} from "./pages/CPlusPlus";
import {Internship} from "./pages/Internship";

export const App = () => {
  return (
      <div className="app">
        <Header/>
        <div className="main">
          <div className="content">
            <Routes>
              <Route index element={<Home/>}/>
              <Route path="cplusplus" element={<CPlusPlus />}/>
              <Route path="intern" element={<Internship />}/>
            </Routes>
          </div>
        </div>
        <Footer/>
      </div>
  );
}

